import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import GridItem from '@/components/Grid/GridItem';
import ReportingColumnList from './ReportingColumnList';

const defaultLineItemColumns = [
  { value: 'gl_code_1', name: 'GL Code 1' },
  { value: 'gl_code_2', name: 'GL Code 2' },
];

export default function LineItemsColumnList({
  column,
  index,
  onUpdateColumn,
  isDisabled,
  availableLineItemColumns = defaultLineItemColumns,
}) {
  const { t } = useTranslation();
  return (
    <GridItem xs={12} sm={12} md={12}>
      <div
        style={{
          marginTop: '16px',
          marginLeft: '8px',
          borderLeft: '3px solid #e0e0e0',
          paddingLeft: '16px',
        }}>
        <Typography
          variant='subtitle2'
          style={{ color: 'grey', marginBottom: '8px' }}>
          {t('lineItemsColumnList.sectionTitle')}
        </Typography>
        <ReportingColumnList
          columns={column.line_items_config || []}
          onUpdateColumn={(liIdx, key, val) => {
            const updated = (column.line_items_config || []).map((liCol, i) =>
              i === liIdx ? { ...liCol, [key]: val } : liCol,
            );
            onUpdateColumn(index, 'line_items_config', updated);
          }}
          onRemoveColumn={(liIdx) => {
            const updated = (column.line_items_config || []).filter(
              (_, i) => i !== liIdx,
            );
            onUpdateColumn(index, 'line_items_config', updated);
          }}
          onAddColumn={() => {
            const updated = [
              ...(column.line_items_config || []),
              { column_name: '', variable_name: '', format: '' },
            ];
            onUpdateColumn(index, 'line_items_config', updated);
          }}
          availableColumns={availableLineItemColumns}
          isDisabled={isDisabled}
          columnTypeLabel='Line Item Column'
        />
      </div>
    </GridItem>
  );
}
